import { createSlice } from "@reduxjs/toolkit";

import * as API from "../config/api";
import { ApiRest } from "react-comun-seps/lib/api/ApiRest";

const initialState = {
  messageSuccess: "",
  messageError: "",
  validarDocumento: {},
};

export const documentoSlice = createSlice({
  name: "documentoSlice",
  initialState,
  reducers: {
    setValidarDocumento: (state, action) => {
      state.validarDocumento = action.payload;
    },
    setMessageSuccess: (state, action) => {
      state.messageSuccess = action.payload;
    },
    setMessageError: (state, action) => {
      state.messageError = action.payload;
    },
  },
});

export const { setValidarDocumento, setMessageSuccess, setMessageError } = documentoSlice.actions;

export const validarDocumentoQR = (param1,param2) => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_VALIDAR_DOCUMENTO}?param1=${param1}&param2=${param2}`);
    dispatch(setValidarDocumento(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

function handleException(exception, dispatch) {
  if (typeof exception === "string") {
    dispatch(setMessageError(exception));
  } else {
    dispatch(setMessageError(exception.data?.message || exception.data));
  }
}

export default documentoSlice.reducer;
